var _path, _path2, _path3, _ellipse, _path4, _ellipse2, _path5, _path6, _path7, _path8, _ellipse3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _path19, _circle2, _circle3, _circle4, _circle5, _path20, _path21, _path22, _path23, _path24, _path25, _circle6, _path26, _path27, _path28, _path29, _path30, _path31, _circle7, _circle8, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _circle9, _path42, _path43, _path44, _ellipse4, _path45, _path46, _path47, _path48, _rect, _rect2, _rect3, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgXmasTree = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 299,
  height: 233,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A9F5FF",
  stroke: "#000",
  d: "M33.463 207.129c-6.422 7.454-1.126 19.006 8.713 19.006h231.252c9.742 0 15.071-11.356 8.845-18.85l-23.941-28.814H58.15l-24.687 28.658Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CD703C",
  stroke: "#000",
  d: "M57.5 70c0-8.56 6.94-15.5 15.5-15.5h84.5v124h-100V70Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4C87BE",
  stroke: "#000",
  d: "M156.5 54.5H242c8.56 0 15.5 6.94 15.5 15.5v108.5h-101v-124Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 157.5,
  cy: 199.135,
  fill: "#000",
  rx: 59.5,
  ry: 12.5
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCFF51",
  stroke: "#000",
  strokeLinejoin: "round",
  d: "M69.56 90.607c.317-.881 1.563-.881 1.88 0l.621 1.719a11 11 0 0 0 6.613 6.613l1.72.62c.88.318.88 1.564 0 1.882l-1.72.62a11.001 11.001 0 0 0-6.613 6.613l-.62 1.719c-.318.881-1.564.881-1.882 0l-.62-1.719a11.001 11.001 0 0 0-6.613-6.613l-1.72-.62c-.88-.318-.88-1.564 0-1.882l1.72-.62a11 11 0 0 0 6.613-6.613l.62-1.72ZM249.559 118.607c.318-.881 1.564-.881 1.882 0l.62 1.719a11.002 11.002 0 0 0 6.613 6.613l1.719.62c.881.318.881 1.564 0 1.882l-1.719.62a11.002 11.002 0 0 0-6.613 6.613l-.62 1.719c-.318.881-1.564.881-1.882 0l-.62-1.719a11.002 11.002 0 0 0-6.613-6.613l-1.719-.62c-.881-.318-.881-1.564 0-1.882l1.719-.62a11.002 11.002 0 0 0 6.613-6.613l.62-1.719ZM199.559 214.607c.318-.881 1.564-.881 1.882 0l.09.249a10.992 10.992 0 0 0 6.613 6.613l.249.09c.881.318.881 1.564 0 1.882l-.249.09a10.992 10.992 0 0 0-6.613 6.613l-.09.249c-.318.881-1.564.881-1.882 0l-.09-.249a10.992 10.992 0 0 0-6.613-6.613l-.249-.09c-.881-.318-.881-1.564 0-1.882l.249-.09a10.992 10.992 0 0 0 6.613-6.613l.09-.249Z"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 236,
  cy: 192.5,
  fill: "#000",
  rx: 13,
  ry: 2.5
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F7258",
  stroke: "#000",
  d: "M232.904 180.101h-.5v11.012l.015.062.485-.125c-.485.125-.485.125-.484.126v.003l.001.004.003.011a1.672 1.672 0 0 0 .154.336c.109.183.287.409.568.627.567.441 1.508.818 3.056.818 1.547 0 2.489-.377 3.055-.818.282-.218.459-.444.569-.627a1.649 1.649 0 0 0 .145-.309l.008-.027.003-.011.001-.004.001-.002v-.001l-.484-.126.484.125.016-.062v-11.012h-7.096Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8A18C",
  d: "M239.494 190.632v-10.031h-3.952v11.874c4.281 0 3.952-1.843 3.952-1.843Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#008F2C",
  stroke: "#000",
  d: "m223.851 181.934-.058.185.081.175c.368.8 1.46 1.984 3.488 2.963 2.044.986 5.065 1.781 9.352 1.781s7.251-.794 9.223-1.785c1.955-.982 2.966-2.175 3.268-2.995l.058-.158-.049-.162-12.022-39.085-.471-1.531-.484 1.527-12.386 39.085Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#68F794",
  d: "M236.571 143h.002a.26.26 0 0 1 .019.067l12.144 39.018c-.492 1.32-3.613 4.453-12.165 4.453-8.447 0 .394-41.186.021-43.471l-.021-.067Z"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 257,
  cy: 196.5,
  fill: "#000",
  rx: 13,
  ry: 2.5
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F7258",
  stroke: "#000",
  d: "M252.733 183.463h-.5v12.422l.016.061.484-.124-.484.125v.001l.001.002.001.005.003.011a1.742 1.742 0 0 0 .167.366c.12.201.317.45.629.693.628.489 1.681.914 3.426.914s2.798-.425 3.427-.914c.312-.243.508-.492.628-.693a1.876 1.876 0 0 0 .158-.337.299.299 0 0 0 .009-.029l.004-.011.001-.005v-.002l.001-.001-.484-.125.484.124.016-.061v-12.422h-7.987Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8A18C",
  d: "M260.213 195.348v-11.385h-4.485v13.476c4.859 0 4.485-2.091 4.485-2.091Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7BF2F",
  stroke: "#000",
  strokeLinejoin: "round",
  d: "M242.565 187.622a.497.497 0 0 0 .049.563c.236.288.673.608 1.298.926.637.323 1.507.662 2.647.971 2.282.617 5.67 1.119 10.498 1.119 4.828 0 8.149-.501 10.348-1.12 1.099-.31 1.925-.651 2.521-.978.581-.319.988-.649 1.193-.961a.499.499 0 0 0 .02-.515l-13.643-24.868a.5.5 0 0 0-.874-.005l-14.057 24.868Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE5A2",
  d: "M256.895 163h.003c.009.01.015.025.021.043l13.782 24.825c-.558.839-4.1 2.833-13.806 2.833-9.587 0 .447-26.205.024-27.658l-.024-.043Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F7258",
  stroke: "#000",
  d: "M151.618 185.026h-.5v12.843l.026.077.474-.158-.474.159.001.001.001.002.002.006.004.013.013.032c.011.024.025.055.043.09.037.072.093.162.172.265.161.206.417.456.817.696.798.479 2.15.908 4.437.908 2.288 0 3.639-.429 4.438-.908.4-.24.656-.49.816-.696a1.81 1.81 0 0 0 .173-.265c.018-.035.032-.066.043-.09l.013-.032.004-.013.002-.006.001-.002v-.001c0-.001.001-.001-.474-.159l.475.158.025-.077v-12.843h-10.532Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8A18C",
  d: "M161.649 197.297v-11.771h-6.688v13.934c7.245 0 6.688-2.163 6.688-2.163Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m101.215 150.191-1.802-.891m1.672 2.896-3.528-.537m4.16 2.746-1.93 1.115"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#008F2C",
  stroke: "#000",
  d: "m97.646 175.879-.031.084v.09c0 2.349 1.784 4.458 4.685 6.28 2.928 1.838 7.13 3.475 12.278 4.843 10.305 2.737 24.512 4.424 40.186 4.424s30.257-1.687 40.937-4.423c5.336-1.367 9.725-3.003 12.792-4.838 3.034-1.816 4.931-3.924 4.931-6.286 0-.674-.18-1.624-.47-2.737-.294-1.125-.711-2.456-1.209-3.908-.996-2.905-2.322-6.317-3.645-9.571a424.245 424.245 0 0 0-5.175-12.146l-.088-.199-.023-.051-.006-.013-.002-.003v-.001l-.456.204.456-.205-.132-.295h-94.332l-.122.326-10.574 28.425Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#68F794",
  d: "M212.919 176.053c0 8.31-26.874 15.047-58.161 15.047-31.286 0-23.203-22.851-14.287-43.472h-5.021 66.894s10.575 23.585 10.575 28.425Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#007825",
  stroke: "#000",
  d: "M203.508 148.185c0 1.497-1.156 3.053-3.576 4.565-2.393 1.496-5.889 2.862-10.254 4.015-8.722 2.306-20.799 3.738-34.158 3.738-13.359 0-25.436-1.432-34.158-3.738-4.365-1.153-7.861-2.519-10.254-4.015-2.419-1.512-3.576-3.068-3.576-4.565 0-1.498 1.157-3.054 3.576-4.566 2.393-1.496 5.889-2.861 10.254-4.015 8.722-2.306 20.799-3.738 34.158-3.738 13.359 0 25.436 1.432 34.158 3.738 4.365 1.154 7.861 2.519 10.254 4.015 2.42 1.512 3.576 3.068 3.576 4.566Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 110.376,
  cy: 153.202,
  r: 6.871,
  fill: "#F7BF2F",
  stroke: "#000",
  strokeLinejoin: "round",
  transform: "rotate(165 110.376 153.202)"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE5A2",
  d: "M106.271 154.301c-1.466-5.47 4.601-7.445 4.601-7.445a6.374 6.374 0 0 1 3.534 11.29l-.002-.006s-6.395 2.647-8.133-3.839Z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 170.827,
  cy: 165.721,
  r: 7.556,
  fill: "#E23055",
  stroke: "#000",
  strokeLinejoin: "round",
  transform: "rotate(146.661 170.827 165.721)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 172.73,
  cy: 164.449,
  r: 4.861,
  fill: "#FE7E98",
  transform: "rotate(146.661 172.73 164.449)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 210.433,
  cy: 170.776,
  r: 5.516,
  fill: "#DFDFDF",
  stroke: "#000",
  strokeLinejoin: "round",
  transform: "rotate(146.661 210.433 170.776)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 211.787,
  cy: 169.874,
  r: 3.455,
  fill: "#fff",
  transform: "rotate(146.661 211.787 169.874)"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F7258",
  stroke: "#000",
  d: "M151.618 135.98h-.5v12.843l.026.077.474-.158-.474.159.001.001.001.003.002.005.004.013.013.032.043.091c.037.071.093.161.172.264.161.207.417.456.817.696.798.479 2.15.908 4.437.908 2.288 0 3.639-.429 4.438-.908a2.9 2.9 0 0 0 .816-.696c.08-.103.135-.193.173-.264l.043-.091.013-.032.004-.013.002-.005.001-.003v-.001c0-.001.001-.001-.474-.159l.475.158.025-.077V135.98h-10.532Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8A18C",
  d: "M161.649 148.251V136.48h-6.688v13.934c7.245 0 6.688-2.163 6.688-2.163Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#008F2C",
  stroke: "#000",
  d: "m113.251 134.037-.031.083v.09c0 1.814 1.366 3.416 3.517 4.777 2.176 1.377 5.292 2.599 9.097 3.617 7.617 2.039 18.112 3.294 29.686 3.294 11.573 0 22.345-1.255 30.239-3.293 3.943-1.018 7.195-2.238 9.474-3.612 2.247-1.355 3.701-2.956 3.701-4.783 0-.518-.137-1.238-.351-2.067a42.308 42.308 0 0 0-.895-2.915c-.736-2.163-1.715-4.703-2.692-7.123a315.874 315.874 0 0 0-2.686-6.433c-.366-.851-.672-1.551-.885-2.039l-.249-.564-.065-.148-.017-.038-.004-.01-.001-.002-.001-.001-.457.203.457-.203-.132-.297H121.174l-.12.327-7.803 21.137Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#68F794",
  d: "M198.433 134.21c0 6.179-19.829 11.188-42.915 11.188-23.085 0-17.276-15.605-11.702-32.325h-.002 46.816s7.803 17.538 7.803 21.137Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#007825",
  stroke: "#000",
  d: "M191.244 113.631c0 1.037-.799 2.153-2.569 3.264-1.745 1.096-4.302 2.101-7.507 2.952-6.402 1.701-15.274 2.758-25.093 2.758-9.82 0-18.692-1.057-25.094-2.758-3.205-.851-5.762-1.856-7.507-2.952-1.769-1.111-2.568-2.227-2.568-3.264s.799-2.153 2.568-3.265c1.745-1.095 4.302-2.1 7.507-2.951 6.402-1.701 15.274-2.759 25.094-2.759 9.819 0 18.691 1.058 25.093 2.759 3.205.851 5.762 1.856 7.507 2.951 1.77 1.112 2.569 2.228 2.569 3.265Z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m179.471 116.737 1.903-.644m-3.23-.865 2.875-2.115m-4.884 1 .577-2.154"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 172.252,
  cy: 119.995,
  r: 5.516,
  fill: "#F7BF2F",
  stroke: "#000",
  strokeLinejoin: "round",
  transform: "rotate(165 172.252 119.995)"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE5A2",
  d: "M169.02 120.859c-1.154-4.306 3.623-5.861 3.623-5.861a5.018 5.018 0 0 1 2.782 8.889l-.001-.005s-5.035 2.084-6.404-3.023Z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F7258",
  stroke: "#000",
  d: "M151.618 100.312h-.5V113.154l.026.077.474-.158-.474.159.001.001.001.003.002.005.004.013.013.032.043.091c.037.071.093.161.172.264.161.207.417.456.817.697.798.478 2.15.907 4.437.907 2.288 0 3.639-.429 4.438-.907.4-.241.656-.49.816-.697.08-.103.135-.193.173-.264l.043-.091.013-.032.004-.013.002-.005.001-.003v-.001c0-.001.001-.001-.474-.159l.475.158.025-.077V100.312h-10.532Z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8A18C",
  d: "M161.649 112.582v-11.77h-6.688v13.933c7.245 0 6.688-2.163 6.688-2.163Z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#008F2C",
  stroke: "#000",
  d: "m125.511 100.816-.031.083v.09c0 1.367 1.027 2.543 2.566 3.517 1.564.989 3.793 1.862 6.503 2.587 5.428 1.453 12.898 2.346 21.131 2.346 8.232 0 15.898-.893 21.521-2.345 2.808-.725 5.135-1.596 6.771-2.583 1.604-.967 2.699-2.142 2.699-3.522 0-.388-.101-.915-.254-1.505a30.234 30.234 0 0 0-.639-2.082c-.524-1.54-1.221-3.347-1.915-5.068a222.084 222.084 0 0 0-2.54-6.024l-.176-.4-.047-.106-.012-.027-.003-.007-.001-.002-.457.203.457-.204-.132-.296h-49.777l-.12.326-5.544 15.019Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#68F794",
  d: "M186.171 100.989c0 4.39-14.089 7.95-30.492 7.95s-10.75-10.355-5.176-22.968h30.124s5.544 12.46 5.544 15.018Z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#007825",
  stroke: "#000",
  d: "M156.076 93.598c6.812 0 12.996-.757 17.493-1.99 2.245-.615 4.098-1.357 5.402-2.202 1.282-.831 2.157-1.847 2.157-3.04s-.875-2.21-2.157-3.04c-1.304-.845-3.157-1.587-5.402-2.203-4.497-1.233-10.681-1.99-17.493-1.99-6.811 0-12.995.757-17.492 1.99-2.246.616-4.098 1.358-5.402 2.203-1.282.83-2.157 1.847-2.157 3.04s.875 2.209 2.157 3.04c1.304.845 3.156 1.587 5.402 2.202 4.497 1.233 10.681 1.99 17.492 1.99Z"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.581,
  cy: 105.84,
  r: 5.516,
  fill: "#7B6AE2",
  stroke: "#000",
  strokeLinejoin: "round",
  transform: "rotate(146.661 136.581 105.84)"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.936,
  cy: 104.937,
  r: 3.455,
  fill: "#B7ABFF",
  transform: "rotate(146.661 137.936 104.937)"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F7258",
  stroke: "#000",
  d: "M151.618 71.332h-.5V84.174l.026.077.474-.158c-.474.158-.474.159-.474.16h.001l.001.003.002.005.004.013.013.032a1.828 1.828 0 0 0 .215.355c.161.207.417.457.817.697.798.479 2.15.907 4.437.907 2.288 0 3.639-.428 4.438-.907.4-.24.656-.49.816-.697a1.848 1.848 0 0 0 .216-.355l.013-.032.004-.013.002-.005.001-.002v-.002l-.474-.159.475.158.025-.077V71.332h-10.532Z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8A18C",
  d: "M161.649 83.603V71.832h-6.688v13.933c7.245 0 6.688-2.162 6.688-2.162Z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m179.484 77.404 1.114 1.672m0-3.344 2.787 2.23m-2.229-4.46h2.229"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#008F2C",
  stroke: "#000",
  d: "m137.784 73.306-.103.24.138.223c.554.885 2.186 2.189 5.231 3.271 3.07 1.091 7.634 1.98 14.143 1.98 6.508 0 10.981-.888 13.939-1.982 1.479-.547 2.584-1.147 3.376-1.718.783-.564 1.288-1.12 1.524-1.593l.102-.205-.088-.211-18.392-44.03-.455-1.087-.466 1.083-18.949 44.029Z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#68F794",
  d: "M157.19 29.475h.004a.228.228 0 0 1 .028.075l18.36 43.954c-.743 1.486-5.461 5.016-18.392 5.016-12.771 0 .596-46.396.032-48.97l-.032-.075Z"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCFF51",
  d: "M154.962 26.688 157.191 20l3.344 6.688 6.688.557-5.016 5.574c.558 2.415 1.672 7.356 1.672 7.802 0 .059-.07.067-.198.033l-3.146.524-4.379-2.786-3.981 2.786.558-7.802-5.016-5.573 4.034-.621 3.211-.494Z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  d: "M163.879 40.621c0 .446-4.087-2.043-6.13-3.344l-1.593 1.115m7.723 2.23c0-.447-1.114-5.388-1.672-7.803l5.016-5.574-6.688-.557L157.191 20l-2.229 6.688-3.211.494-4.034.62 5.016 5.574-.558 7.803 3.981-2.787m7.723 2.23-3.344.556-4.379-2.786"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD260",
  d: "m144.931 28.36 2.787-.557 5.016 5.573-.558 7.803h-2.786l.557-7.803-5.016-5.015Z"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  d: "m149.947 33.377-5.016-5.016 2.787-.558 5.016 5.573m-2.787 0-.557 7.803h2.786l.558-7.803m-2.787 0h2.787"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD260",
  stroke: "#000",
  strokeLinejoin: "round",
  d: "m153.849 20.557 3.344-.557-2.23 6.688-3.344.557 2.23-6.688Z"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 174.468,
  cy: 71.274,
  r: 5.516,
  fill: "#F7BF2F",
  stroke: "#000",
  strokeLinejoin: "round",
  transform: "rotate(150 174.468 71.274)"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE5A2",
  d: "M172.24 72.946c-2.23-3.86 1.316-6.598 1.316-6.598a5.018 5.018 0 0 1 4.988 7.865l-.002-.004s-3.659 3.316-6.302-1.263Z"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M183.609 86c1.926 1.752 1 5.5-6.5 6.5-4.5 3.5-10 0-10 0s-4.5 2.5-8.999 1c-1.317-1.26-1.135-2.61 1.499-4.5 2.107-1.512 5.402-1.63 6.5-1 .878-1.26 2.866-3.386 5.5-4.394 2.633-1.007 5.402.42 6.5 1.26 1.536-.42 4.114-.126 5.5 1.134Z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M172.109 88c.782-.444 1.565-1 3.13-1 .99 0 2.087.778 2.348 1 .261-.333 1.017-1 1.956-1 .94 0 1.566.615 1.566.615"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 58.5,
  cy: 204.879,
  fill: "#000",
  rx: 14.5,
  ry: 3
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F7258",
  stroke: "#000",
  d: "M53.733 191.175h-.5v12.422l.016.061.484-.124a34.09 34.09 0 0 0-.484.125v.003l.002.005.003.011.009.029.03.084c.028.066.068.153.128.253.12.2.317.45.629.693.628.489 1.681.914 3.426.914s2.798-.425 3.427-.914c.312-.243.508-.493.628-.693a1.864 1.864 0 0 0 .159-.337.84.84 0 0 0 .008-.029l.004-.011v-.005l.001-.002v-.001l-.483-.125.484.124.016-.061v-12.422h-7.987Z"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8A18C",
  d: "M61.213 203.059v-11.384h-4.486v13.476c4.86 0 4.486-2.092 4.486-2.092Z"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "#008F2C",
  stroke: "#000",
  d: "m43.523 193.208-.058.184.08.176c.41.889 1.634 2.223 3.928 3.33 2.308 1.114 5.727 2.015 10.584 2.015 4.857 0 8.21-.901 10.437-2.019 2.21-1.11 3.342-2.453 3.676-3.362l.059-.159-.05-.161-13.644-44.359-.47-1.531-.484 1.527-14.058 44.359Z"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  fill: "#68F794",
  d: "M57.895 149h.003a.298.298 0 0 1 .02.076l13.783 44.283c-.558 1.497-4.1 5.054-13.806 5.054-9.587 0 .447-46.744.024-49.337l-.024-.076Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 15,
  x: 47.5,
  y: 170.5,
  fill: "#fff",
  stroke: "#000",
  rx: 5.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 7,
  x: 48,
  y: 177,
  fill: "#000",
  rx: 3
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 15,
  x: 58.5,
  y: 170.5,
  fill: "#fff",
  stroke: "#000",
  rx: 5.5
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m66 178-5 2.222L66 182"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5C00",
  stroke: "#000",
  d: "M61.72 185.293c0 1.57-1.194 2.794-2.61 2.794-1.415 0-2.61-1.224-2.61-2.794s1.195-2.793 2.61-2.793c1.416 0 2.61 1.223 2.61 2.793Z"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M41.516 212.688c-5.6 0-10.333 2.333-12 3.5-3 0-9.1.9-9.5 4.5-.5 4.5 10.5 6 28.5 6s11.5-2.5 22-2.5 14.5-1 14.5-2-.5-3-3.5-4-6 0-8.5-1-5-5.5-9.5-6-8 0-11.5 1.5-3.5 0-10.5 0Z"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M59 220.578c1-.667 2-1.5 4-1.5 1.265 0 2.667 1.167 3 1.5.333-.5 1.3-1.5 2.5-1.5s2 .922 2 .922M41 220c.5-.667 1.9-2 3.5-2s2.667.667 3 1c.5-.333 2-1 4-1"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  stroke: "#000",
  d: "M83 71.466v126.629c0 5.353 5.5 18.405 72.994 18.405 53.006 0 75.818-14 75.818-18.405V71.466C231.812 46.748 204.589 4 155.994 4S83 44.732 83 71.466Z"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 5,
  d: "M131.678 20.53c-4.822 2.205-16.201 9.479-23.145 20.94M104.676 48.635c-.735 1.47-2.425 5.07-3.306 7.715"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M93.565 207c-2.4.4-3.88 2.833-4.547 4 0 0-3.5 0-4.001 2.5-.31 1.55 3.714 1.833 5.048 2-.167.167 0 .7 2 1.5s5.833-.333 7.5-1c.166.5 1 1.6 3 2 2 .4 4.833-.167 6-.5 0 .5 1.2 1.7 6 2.5s10.666-.333 13-1c.5.667 4.241 3 11.452 3 8 0 12.881-1 13.048-2.5.666.333 2.652 1.1 5.452 1.5 2.8.4 6.334-.833 7-2 1.834.5 6.5 1 7-3 .224-1.789-1-5.5-4-7-2.987-1.494-7.086-.674-7.942-.502l-.01.002c-.834-1-3.5-3.1-7.5-3.5-4-.4-8.334 1.167-10 2-.667-1-2.6-3-5-3s-4.334.333-5 .5c-.667-.833-2.8-2.5-6-2.5s-5.334 1.667-6 2.5c-.5-.5-1.9-1.5-3.5-1.5s-3 1.333-3.5 2c-1-.667-3.7-2-6.5-2s-5.834 4-7 6c-1-.834-3.6-2.4-6-2Z"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M146.518 212.5c1-.667 2-1.5 4-1.5 1.264 0 2.666 1.167 3 1.5.333-.5 1.3-1.5 2.5-1.5s2 .922 2 .922M114.518 209.5c1-.667 2-1.5 4-1.5 1.264 0 2.666 1.167 3 1.5.333-.5 1.3-1.5 2.5-1.5s2 .922 2 .922"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M270.499 199.688c5.6 0 10.334 2.333 12 3.5 3 0 9.1.9 9.5 4.5.5 4.5-10.5 6-28.5 6s-11.5-2.5-22-2.5-14.5-1-14.5-2 .5-3 3.5-4 6 0 8.5-1 5-5.5 9.5-6 8 0 11.5 1.5 3.5 0 10.5 0Z"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M234.242 216.443c-8.5 0-19-1-22-1.5-5.5-3.5 0-6.5 7-8.5 7-1.999 9 3.5 11.5 2s7.5-2 15 1.5-3 6.5-11.5 6.5Z"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M271 207.5c1-.667 2-1.5 4-1.5 1.265 0 2.667 1.167 3 1.5.333-.5 1.3-1.5 2.5-1.5s2 .922 2 .922M251 204.5c1-.667 2-1.5 4-1.5 1.265 0 2.667 1.167 3 1.5.333-.5 1.3-1.5 2.5-1.5s2 .922 2 .922M225 212c.696-.444 1.391-1 2.783-1 .88 0 1.855.778 2.087 1 .231-.333.904-1 1.739-1 .834 0 1.391.615 1.391.615"
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 29,
  r: 4,
  fill: "#fff"
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 42,
  r: 4,
  fill: "#fff"
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 112,
  r: 4,
  fill: "#fff"
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 63,
  r: 2,
  fill: "#fff"
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 279,
  cy: 107,
  r: 2,
  fill: "#fff"
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  cx: 268,
  cy: 149,
  r: 2,
  fill: "#fff"
})), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  cx: 265,
  cy: 22,
  r: 2,
  fill: "#fff"
})), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
  cx: 187,
  cy: 2,
  r: 2,
  fill: "#fff"
})), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 153,
  r: 2,
  fill: "#fff"
})), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 17,
  r: 2,
  fill: "#fff"
})), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 193,
  r: 4,
  fill: "#fff"
})), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
  cx: 221,
  cy: 38,
  r: 4,
  fill: "#fff"
})), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
  cx: 251,
  cy: 55,
  r: 4,
  fill: "#fff"
})), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
  cx: 294,
  cy: 161,
  r: 4,
  fill: "#fff"
})));
export default SvgXmasTree;